import { roleActionTypes } from '../actions/types';

const initialState = {
  roles: [],
  status: null,
};

export function role(state = initialState, action) {
  switch (action.type) {
    case roleActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case roleActionTypes.FETCH_REQUEST:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case roleActionTypes.FETCH_SUCCESS:
      return {
        ...state,
        status: 'success',
        roles: action.roles,
        error: null,
      };
    case roleActionTypes.FETCH_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.error,
      };
    default:
      return state;
  }
}
